import { AppName } from '@core/app/scripts/services/app-name';
export { AppName };

/**
 * # appName
 * Override the {@link coreModule.appName} value.
 */
export const AppNameProvider: { provide: string; useValue: AppName } = {
  provide: 'appName',
  useValue: 'gate',
};
